
<template>
  <div id="app">
    <!--    <img src="./assets/logo.png">-->
    <menu-layout v-if="$route.meta.showNavMenu && !isMobile">
      <router-view />
    </menu-layout>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>import logo from './assets/logo-szfn.png'
import tenant from './apis/tenant'
import apis from './apis/column'
import home from './apis/home'
import login from './apis/login'
import { mapGetters } from 'vuex'
import getLocal from '@/common/cookie'

const MOBILE_REGEX = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i

export default {
  name: 'App',
  data () {
    return {
      logo,
      isMobile: null,
      mobileUrl: 'https://mobile.tpr.ndlink.cn'
    }
  },
  computed: {
    ...mapGetters(['columnItemParent'])
  },
  created () {
    this.checkIsMobile()
    this.initStoreFromSession()

    window.addEventListener('beforeunload', () => {
      try {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      } catch (e) {
        console.error('Failed to save state to sessionStorage:', e)
      }
    })

    this.$nextTick(() => {
      this.setFavicon()
      this.handleContextMenuAndKeys()
    })

    if (this.columnItemParent) {
      this.$store.commit('SET_ACTIVEINDEX', this.columnItemParent.id)
    }
    this.getTenant(this.$route.query.tenantId)
    this.getLoginStatus()
  },
  mounted () {},
  methods: {
    checkIsMobile () {
      this.isMobile = MOBILE_REGEX.test(navigator.userAgent)
    },
    initStoreFromSession () {
      try {
        const savedState = sessionStorage.getItem('store')
        if (savedState) {
          const parsed = JSON.parse(savedState)
          this.$store.replaceState(Object.assign({}, this.$store.state, parsed))
        }
      } catch (e) {
        console.error('Failed to restore state from sessionStorage:', e)
      }
    },
    setFavicon () {
      let link = document.querySelector("link[rel*='icon']")
      if (!link) {
        link = document.createElement('link')
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.logo
    },
    handleContextMenuAndKeys () {
      document.oncontextmenu = () => false
      document.onselectstart = () => false

      document.onkeydown = (e) => {
        if (!e) return
        const keyCode = e.keyCode || e.which
        const forbiddenKeys = [123, 17] // F12, Ctrl
        if (forbiddenKeys.includes(keyCode)) {
          e.preventDefault()
          e.stopPropagation()
          return false
        }
      }
    },
    async getTenant (tenantId) {
      console.log('tenantId', tenantId)
      try {
        const routeName = window.location.pathname
        const routeMap = {
          '/course': 'pages/course/coursedetail',
          '/newcourse': 'pages/course/coursedetail',
          '/courselive': 'pages/live/courselive'
        }
        var res = {}
        if (tenantId) {
          res = await tenant.getTenantById({tenantId: tenantId})
        } else {
          res = await tenant.getTenant()
        }
        var isPc = await this.handleDesktopRedirect(routeName)
        if (this.isMobile && !isPc) {
          await this.handleMobileRedirect(res, routeName, routeMap)
        } else {
          await this.handleDesktopSetup(res)
        }
      } catch (error) {
        console.error('Error fetching tenant info:', error)
        // 可以考虑添加用户友好的错误提示
        // this.$message.error('获取租户信息失败')
      }
    },
    // 一些特殊的报名还是需要保留在pc端
    async handleDesktopRedirect (routeName) {
      const pcMap = ['/enroll', '/enrollUser', '/pay', '/order', '/enrollUserInfo', '/paySuccess',
        '/companyPay', '/checkPay', '/updateEnrollUserInfo', '/orderpay', '/orderpaySuccess',
        '/weChatPayment', '/wechatpayment', '/paymentsuccess', '/paymenterror', '/goodspay']
      var isPc = false
      if ((pcMap).includes(routeName)) {
        isPc = true
      } else {
        isPc = false
      }
      return isPc
    },
    // 处理移动端重定向
    async handleMobileRedirect (tenantInfo, routeName, routeMap) {
      const safeTenantId = encodeURIComponent(tenantInfo.id)
      const mobileRoute = routeMap[routeName]
      const queryString = window.location.search
      let mobileUrl = this.mobileUrl

      if (mobileRoute) {
        mobileUrl = `${mobileUrl}/${mobileRoute}`
      }

      // 构建查询参数
      const urlParams = new URLSearchParams()
      urlParams.append('tenantId', safeTenantId)

      // 添加其他查询参数
      if (queryString) {
        const existingParams = new URLSearchParams(queryString.startsWith('?') ? queryString.slice(1) : queryString)
        for (const [key, value] of existingParams) {
          urlParams.append(key, value)
        }
      }

      const finalUrl = `${mobileUrl}?${urlParams.toString()}`
      window.location.replace(finalUrl)
    },
    // 处理桌面端设置
    async handleDesktopSetup (tenantInfo) {
      this.$store.commit('SET_TENANT', tenantInfo)
      localStorage.setItem('tenantId', tenantInfo.id)

      await Promise.all([
        this.getColumnTreeList(),
        this.getWebsit()
      ])
    },

    async getColumnTreeList () {
      try {
        const res = await apis.listColumnTree()
        this.$store.commit('SET_COLUMNTREELIST', res)
      } catch (error) {
        console.error('Error fetching column tree list:', error)
      }
    },
    async getWebsit () {
      try {
        const res = await home.getWebsit()
        this.$store.commit('SET_BANNER', res.bannerPath)
        this.$store.commit('SET_WEBSIT', res)
        this.$store.commit('SET_SITEINTRO', res.siteIntro)
        document.title = res.siteName
      } catch (error) {
        console.error('Error fetching website config:', error)
      }
    },
    async getLoginStatus () {
      const token = getLocal.getCookie('token')
      if (token) {
        await login.getLoginStatus({token: token}).then(res => {
          var {code} = res.data
          if (code != 0) {
            this.removeStore()
          }
        })
      } else {
        this.removeStore()
      }
    },
    removeStore () {
      this.$store.dispatch('logout')
      this.$store.dispatch('removeRedirect')
      this.$store.commit('SET_USER')
      this.$cookie.delete('token')
      this.$store.commit('SET_ACTIVEINDEX', '')
      localStorage.removeItem('accessToken')
    },
    // 改进的查询字符串构建方法（如果需要）
    buildQueryString (query) {
      if (!query || Object.keys(query).length === 0) {
        return ''
      }

      const params = new URLSearchParams()
      Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, String(value))
        }
      })

      const result = params.toString()
      return result ? `?${result}` : ''
    }

  }
}
</script>

<style>
#app {
  font-family: Source Han Sans CN, Source Han Sans CN;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-size: 100% 100%;
  overflow: hidden;
}
@media (max-width: 950px) {
  #app {
    overflow-y: auto;
  }
}
</style>
